// Elenco Paesi (nome in italiano) con codice ISO 3166-1 alpha-2 per le bandierine.
export const COUNTRIES = [
  { name: "Afghanistan", code: "AF" },
  { name: "Albania", code: "AL" },
  { name: "Algeria", code: "DZ" },
  { name: "Arabia Saudita", code: "SA" },
  { name: "Argentina", code: "AR" },
  { name: "Armenia", code: "AM" },
  { name: "Australia", code: "AU" },
  { name: "Austria", code: "AT" },
  { name: "Azerbaigian", code: "AZ" },
  { name: "Bahrein", code: "BH" },
  { name: "Bangladesh", code: "BD" },
  { name: "Belgio", code: "BE" },
  { name: "Bielorussia", code: "BY" },
  { name: "Bolivia", code: "BO" },
  { name: "Bosnia ed Erzegovina", code: "BA" },
  { name: "Brasile", code: "BR" },
  { name: "Bulgaria", code: "BG" },
  { name: "Canada", code: "CA" },
  { name: "Cile", code: "CL" },
  { name: "Cina", code: "CN" },
  { name: "Cipro", code: "CY" },
  { name: "Colombia", code: "CO" },
  { name: "Corea del Nord", code: "KP" },
  { name: "Corea del Sud", code: "KR" },
  { name: "Costa Rica", code: "CR" },
  { name: "Croazia", code: "HR" },
  { name: "Cuba", code: "CU" },
  { name: "Danimarca", code: "DK" },
  { name: "Ecuador", code: "EC" },
  { name: "Egitto", code: "EG" },
  { name: "Emirati Arabi Uniti", code: "AE" },
  { name: "Estonia", code: "EE" },
  { name: "Etiopia", code: "ET" },
  { name: "Filippine", code: "PH" },
  { name: "Finlandia", code: "FI" },
  { name: "Francia", code: "FR" },
  { name: "Georgia", code: "GE" },
  { name: "Germania", code: "DE" },
  { name: "Giappone", code: "JP" },
  { name: "Giordania", code: "JO" },
  { name: "Grecia", code: "GR" },
  { name: "Guatemala", code: "GT" },
  { name: "India", code: "IN" },
  { name: "Indonesia", code: "ID" },
  { name: "Iran", code: "IR" },
  { name: "Iraq", code: "IQ" },
  { name: "Irlanda", code: "IE" },
  { name: "Islanda", code: "IS" },
  { name: "Israele", code: "IL" },
  { name: "Italia", code: "IT" },
  { name: "Kazakistan", code: "KZ" },
  { name: "Kenya", code: "KE" },
  { name: "Kuwait", code: "KW" },
  { name: "Lettonia", code: "LV" },
  { name: "Libano", code: "LB" },
  { name: "Libia", code: "LY" },
  { name: "Lituania", code: "LT" },
  { name: "Lussemburgo", code: "LU" },
  { name: "Malaysia", code: "MY" },
  { name: "Marocco", code: "MA" },
  { name: "Messico", code: "MX" },
  { name: "Moldova", code: "MD" },
  { name: "Montenegro", code: "ME" },
  { name: "Nigeria", code: "NG" },
  { name: "Norvegia", code: "NO" },
  { name: "Nuova Zelanda", code: "NZ" },
  { name: "Paesi Bassi", code: "NL" },
  { name: "Pakistan", code: "PK" },
  { name: "Palestina", code: "PS" },
  { name: "Panama", code: "PA" },
  { name: "Paraguay", code: "PY" },
  { name: "Perù", code: "PE" },
  { name: "Polonia", code: "PL" },
  { name: "Portogallo", code: "PT" },
  { name: "Qatar", code: "QA" },
  { name: "Regno Unito", code: "GB" },
  { name: "Repubblica Ceca", code: "CZ" },
  { name: "Romania", code: "RO" },
  { name: "Russia", code: "RU" },
  { name: "Serbia", code: "RS" },
  { name: "Singapore", code: "SG" },
  { name: "Siria", code: "SY" },
  { name: "Slovacchia", code: "SK" },
  { name: "Slovenia", code: "SI" },
  { name: "Spagna", code: "ES" },
  { name: "Stati Uniti", code: "US" },
  { name: "Sudafrica", code: "ZA" },
  { name: "Sudan", code: "SD" },
  { name: "Svezia", code: "SE" },
  { name: "Svizzera", code: "CH" },
  { name: "Thailandia", code: "TH" },
  { name: "Tunisia", code: "TN" },
  { name: "Turchia", code: "TR" },
  { name: "Ucraina", code: "UA" },
  { name: "Ungheria", code: "HU" },
  { name: "Unione Europea", code: "EU" },
  { name: "Uruguay", code: "UY" },
  { name: "Uzbekistan", code: "UZ" },
  { name: "Venezuela", code: "VE" },
  { name: "Vietnam", code: "VN" },
  { name: "Yemen", code: "YE" },
];

export const COUNTRY_CODE_BY_NAME = COUNTRIES.reduce((acc, c) => {
  acc[c.name] = c.code;
  return acc;
}, {});
